import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import useDebounce from "../../hooks/useDebounce";
import ReactPaginate from "react-paginate";
import iconEdit from "../../assets/images/product/edit.svg";
import iconDetail from "../../assets/images/employee/detail.svg";
import icontrash from "../../assets/images/product/trash.svg";
import iconShare from "../../assets/images/icon_share.png";
import { AiOutlineMore } from "react-icons/ai";
import DeleteDialog from "../../components/dialog/delete";
import FormNew from "./formCustomers/formNew";
import SearchableSelect from "../../components/selectForm";
import FormInfo from "./formCustomers/formInfo";
import { useConditionalLists, useCustomerList } from "../../hooks/useCustomer";
import SearchBox from "./searchBox";
import toast from "react-hot-toast";
import { customerCall } from "../../api/customer";
import FormNewBusiness from "./formCustomers/formNewBusiness";
import FormInfoBusiness from "./formCustomers/formInfoBusiness";
import { GenderCustomers, TypeCustomers } from "../../utils/contants";
import SearchableSelectMulti from "../../components/selectForm/mutiSelect";
import FormShare from "./formCustomers/formShare";

const TableCustomers = ({
  tableData,
  search,
  setSearch,
  employeeId,
  setEmployeeId,
  projectId,
  setProjectId,
  customerTypeId,
  setCustomerTypeId,
  totalPages,
  handlePageChange,
  isLoading,
  isRefetching,
  currentPage,
  entries,
  startEntry,
  endEntry,
  refetch,
  setGender,
  setType,
  saleBlockId,
  setSaleBlockId,
  saleAreaId,
  setSaleAreaId,
}) => {
  // table
  const {
    isOpen: isOpenCustomer,
    onOpen: onOpenCustomer,
    onClose: onCloseCustomer,
  } = useDisclosure();

  const {
    isOpen: isOpenCustomerShare,
    onOpen: onOpenCustomerShare,
    onClose: onCloseCustomerShare,
  } = useDisclosure();

  const {
    isOpen: isOpenCustomerBusiness,
    onOpen: onOpenCustomerBusiness,
    onClose: onCloseCustomerBusiness,
  } = useDisclosure();

  // const [customerType, setCustomerType] = useState(1);
  const [searchTermEmployee, setSearchTermEmployee] = useState("");
  const debouncedSearchTermEmployee = useDebounce(searchTermEmployee, 500);
  const [searchTermProject, setSearchTermProject] = useState("");
  const debouncedSearchTermProject = useDebounce(searchTermProject, 500);
  const [searchTermCustomerType, setSearchTermCustomerType] = useState("");
  const debouncedSearchTermCustomerType = useDebounce(
    searchTermCustomerType,
    500
  );

  const [searchTermSaleBlock, setSearchTermSaleBlock] = useState("");
  const debouncedSearchTermSaleBlock = useDebounce(searchTermSaleBlock, 500);
  const [searchTermSaleArea, setSearchTermSaleArea] = useState("");
  const debouncedSearchTermSaleArea = useDebounce(searchTermSaleArea, 500);

  const { employeeList, isLoading: employeeIsLoading } = useConditionalLists(
    debouncedSearchTermEmployee,
    { employee: true }
  );
  const { projectList } = useConditionalLists(debouncedSearchTermProject, {
    project: true,
  });
  const { customerTypeList, isLoading: customerTypeIsLoading } =
    useConditionalLists(debouncedSearchTermCustomerType, {
      customerType: true,
    });

  const { saleBlockList } = useConditionalLists(debouncedSearchTermSaleBlock, {
    saleBlock: true,
  });
  const { saleAreaList } = useConditionalLists(debouncedSearchTermSaleArea, {
    saleArea: true,
  });

  const formatEntriesForSelect = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({
      value: key,
      label: value,
    }));
  const formatEntriesForSelectMulti = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({
      key: key,
      value: value,
    }));

  const employees = useMemo(() => {
    if (!employeeList) return [];
    return formatEntriesForSelect(employeeList);
  }, [employeeList]);

  const projects = useMemo(() => {
    if (!projectList) return [];
    return formatEntriesForSelectMulti(projectList);
  }, [projectList]);

  const customerTypeLists = useMemo(() => {
    if (!customerTypeList) return [];
    return formatEntriesForSelect(customerTypeList);
  }, [customerTypeList]);

  const saleBlockLists = useMemo(() => {
    if (!saleBlockList) return [];
    return formatEntriesForSelectMulti(saleBlockList);
  }, [saleBlockList]);

  const saleAreaLists = useMemo(() => {
    if (!saleAreaList) return [];
    return formatEntriesForSelectMulti(saleAreaList);
  }, [saleAreaList]);

  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });

  // edit
  const [dataEdit, setDataEdit] = useState(null);

  const handleOpenEditCustomer = (data) => {
    setDataEdit(data);
  };

  const handleCloseEditCustomer = (type) => {
    setDataEdit(null);

    if (type === 1) {
      onCloseCustomer();
    } else {
      onCloseCustomerBusiness();
    }
  };

  const onSubmitEdit = async (data) => {
    const toastCreate = toast.loading("Đang sửa khách hàng ...");
    try {
      const { id, ...option } = data;
      let filteredData = Object.fromEntries(
        Object.entries(option).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null
        )
      );

      delete filteredData?.representativeVnidImage;
      delete filteredData?.businessAddress;
      delete filteredData?.businessLocationAddress;
      delete filteredData?.businessRegistrationDate;
      delete filteredData?.idRepresentativeCardFrontImage;
      delete filteredData?.idRepresentativeCardBackImage;
      if (filteredData?.businessTaxCode) {
        delete filteredData.businessTaxCode;
      }
      if (filteredData?.businessRegistrationPlace) {
        delete filteredData.businessRegistrationPlace;
      }
      if (filteredData?.representativeName) {
        delete filteredData.representativeName;
      }
      if (filteredData?.representativeIdNumber) {
        delete filteredData.representativeIdNumber;
      }
      if (filteredData?.representativeIdIssuedDate) {
        delete filteredData.representativeIdIssuedDate;
      }
      if (filteredData?.representativeIdIssuedPlace) {
        delete filteredData.representativeIdIssuedPlace;
      }
      if (filteredData?.representativePosition) {
        delete filteredData.representativePosition;
      }

      delete filteredData?.businessRegistrationImage;

      if (filteredData?.isBusiness) {
        delete filteredData.isBusiness;
      }
      if (filteredData?.customer_shares) {
        delete filteredData.customer_shares;
      }

      await customerCall.update(id, { ...filteredData });
      await refetch();
      setDataEdit(null);
      onCloseCustomer();
      toast.success("Sửa thành công");
    } catch (error) {
      console.error("Error", error);
      toast.error("Có lỗi xảy ra khi sửa");
    }

    toast.dismiss(toastCreate);
  };

  const onSubmitEditBusiness = async (data) => {
    const toastCreate = toast.loading("Đang sửa khách hàng ...");
    try {
      const { id, ...option } = data;
      let filteredData = Object.fromEntries(
        Object.entries(option).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null
        )
      );

      delete filteredData?.idCardFrontImage;
      delete filteredData?.idCardBackImage;
      delete filteredData?.vnidImage;
      delete filteredData?.isNewDivision;

      if (filteredData?.identificationNumber) {
        delete filteredData.identificationNumber;
      }
      if (filteredData?.dateOfIdentification) {
        delete filteredData.dateOfIdentification;
      }
      if (filteredData?.placeOfIdentification) {
        delete filteredData.placeOfIdentification;
      }
      if (filteredData?.permanentAddress) {
        delete filteredData.permanentAddress;
      }
      if (filteredData?.permanentAddressProvince) {
        delete filteredData.permanentAddressProvince;
      }
      if (filteredData?.permanentAddressDistrict) {
        delete filteredData.permanentAddressDistrict;
      }
      if (filteredData?.permanentAddressWard) {
        delete filteredData.permanentAddressWard;
      }
      if (filteredData?.currentAddress) {
        delete filteredData.currentAddress;
      }
      if (filteredData?.currentAddressProvince) {
        delete filteredData.currentAddressProvince;
      }
      if (filteredData?.currentAddressDistrict) {
        delete filteredData.currentAddressDistrict;
      }
      if (filteredData?.currentAddressWard) {
        delete filteredData.currentAddressWard;
      }
      if (filteredData?.dateOfBirth) {
        delete filteredData.dateOfBirth;
      }
      if (filteredData?.jobId) {
        delete filteredData.jobId;
      }
      delete filteredData.isBusiness;
      if (filteredData?.customer_shares) {
        delete filteredData.customer_shares;
      }

      await customerCall.updateBusiness(id, { ...filteredData });
      await refetch();
      setDataEdit(null);
      onCloseCustomerBusiness();
      toast.success("Sửa thành công");
    } catch (error) {
      console.error("Error", error);
      toast.error("Có lỗi xảy ra khi sửa");
    }

    toast.dismiss(toastCreate);
  };

  // del
  const [dataDel, setDataDel] = useState(null);
  const handleOpenDeleteCustomer = (data) => {
    setDataDel(data);
  };

  const handleCloseDeleteCustomer = () => {
    setDataDel(null);
  };
  const onSubmitDelete = async () => {
    const toastEdit = toast.loading("Đang xóa dữ liệu ...");
    try {
      const { id } = dataDel;
      await customerCall.delete(id);
      await refetch();
      setDataDel(null);
      toast.success("Xóa thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi xóa");
    }
    toast.dismiss(toastEdit);
  };

  //share
  const [dataShare, setDataShare] = useState(null);
  const handleOpenShareeteCustomer = (data) => {
    setDataShare(data);
    onOpenCustomerShare();
  };

  const onSubmitShare = async (data) => {
    const toastEdit = toast.loading("Đang chia sẻ khách hàng ...");
    try {
      const { id } = dataShare;
      await customerCall.share(id, data);
      await refetch();
      setDataShare(null);
      toast.success("Xóa thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi chia sẻ khách hàng");
    }
    toast.dismiss(toastEdit);
  };

  // detail
  const [dataDetail, setDataDetail] = useState(null);
  const handleOpenDetailCustomer = (data) => {
    setDataDetail(data);
  };

  const handleCloseDetailCustomer = () => {
    setDataDetail(null);
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={{ base: "32px" }}
            p={"16px 16px 12px 16px"}
          >
            <Flex
              alignItems={"flex-start"}
              gap={{ base: "16px 32px" }}
              flex={"1"}
              flexDirection={"column"}
            >
              <InputGroup
                maxW="42vw"
                minW={"42vw"}
                borderRadius={{ base: "8px" }}
                w={{ base: "100%" }}
              >
                <Input
                  placeholder="Nhập tên khách hàng, số điện thoại, ..."
                  type="text"
                  borderRadius={{ base: "8px" }}
                  border={{ base: "1px solid var(--color-boder)" }}
                  onChange={onChangeSearch}
                />
                <InputRightElement
                  borderTopRightRadius={"8px"}
                  borderBottomRightRadius={"8px"}
                  pointerEvents="none"
                  backgroundImage="var(--color-button)"
                  cursor={"pointer"}
                >
                  <SearchIcon color="var(--color-main)" />
                </InputRightElement>
              </InputGroup>
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                flexWrap={"wrap"}
                w={"100%"}
              >
                <SearchableSelect
                  isShowSearch={true}
                  options={GenderCustomers}
                  initialSelectedOption={{ key: null, value: "Chọn giới tính" }}
                  setValue={setGender}
                  // minW={"249px"}
                />

                <SearchableSelect
                  // isShowSearch={true}
                  options={TypeCustomers}
                  initialSelectedOption={{
                    key: null,
                    value: "Loại khách hàng",
                  }}
                  setValue={setType}
                  // minW={"249px"}
                />

                <SearchBox
                  isSearchable={true}
                  placeholder="Chọn phân loại"
                  selectedMain={customerTypeId}
                  onChange={(option) => setCustomerTypeId(option)}
                  data={customerTypeLists}
                  isLoading={customerTypeIsLoading}
                  searchTerm={searchTermCustomerType}
                  setSearchTerm={setSearchTermCustomerType}
                />

                {/* <SearchBox
                  isSearchable={true}
                  placeholder="Chọn dự án"
                  selectedMain={projectId}
                  onChange={(option) => setProjectId(option)}
                  data={projects}
                  isLoading={projectIsLoading}
                  searchTerm={searchTermProject}
                  setSearchTerm={setSearchTermProject}
                /> */}
                <SearchableSelectMulti
                  isShowSearch={true}
                  options={projects}
                  setValue={setProjectId}
                  minW={"249px"}
                  placeholder="Chọn dự án quan tâm"
                />

                <SearchBox
                  isSearchable={true}
                  placeholder="Chọn nhân viên tạo"
                  selectedMain={employeeId}
                  onChange={(option) => setEmployeeId(option)}
                  data={employees}
                  isLoading={employeeIsLoading}
                  searchTerm={searchTermEmployee}
                  setSearchTerm={setSearchTermEmployee}
                />

                <SearchableSelect
                  isShowSearch={true}
                  options={saleBlockLists}
                  initialSelectedOption={{
                    key: null,
                    value: "Chọn khối",
                  }}
                  setValue={setSaleBlockId}
                  // minW={"249px"}
                />

                <SearchableSelect
                  isShowSearch={true}
                  options={saleAreaLists}
                  initialSelectedOption={{
                    key: null,
                    value: "Chọn vùng",
                  }}
                  setValue={setSaleAreaId}
                  // minW={"249px"}
                />
              </Flex>
            </Flex>
          </Flex>
          <Box width={"100%"} height={"100%"}>
            <TableContainer
              w={"100%"}
              maxH="calc(100vh - 350.5px)"
              overflowY="auto"
            >
              <Skeleton isLoaded={!isLoading && !isRefetching}>
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      {tableData.headers.map((e, index) => {
                        let width = "auto";
                        let textAlign = "auto";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "center";
                        } else if (e.key === "contact") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "dateOfBirth") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "gender") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "employee") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "saleBlock") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "saleArea") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "representativeGender") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "status") {
                          width = "10%";
                          textAlign = "center";
                        } else if (e.key === "name") {
                          width = "25%";
                          textAlign = "start";
                        } else if (e.key === "identityNumber") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "identificationNumber") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "identificationInfo") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "identificationInfoBusiness") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "type") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "currentAddress") {
                          width = "40%";
                          textAlign = "end";
                        } else if (e.key === "project") {
                          width = "20%";
                          textAlign = "start";
                        } else {
                          width = "20%";
                          textAlign = "end";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                  </Thead>
                  <Tbody w={"100%"} h={"100%"}>
                    {tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.detail;
                        delete items.edit;
                        delete items.isNewDivision;
                        const keyValues = Object.keys(items);
                        return (
                          <Tr key={rowIndex} h={"72px"}>
                            <Td
                              p={"16px 16px 8px 16px"}
                              w={"2%"}
                              bg={
                                rowIndex % 2 === 0
                                  ? "var(--color-main)"
                                  : "var(--fill-avatar)"
                              }
                              verticalAlign={"top"}
                            >
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                  alignItems={"unset"}
                                >
                                  <AiOutlineMore fontSize={"20px"} />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleOpenDetailCustomer(e?.detail)
                                    }
                                  >
                                    <Image src={iconDetail} /> Xem chi tiết
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      handleOpenEditCustomer(e?.edit);
                                      if (e?.edit?.isBusiness) {
                                        onOpenCustomerBusiness();
                                      } else {
                                        onOpenCustomer();
                                      }
                                    }}
                                    gap={"16px"}
                                  >
                                    <Image src={iconEdit} /> Chỉnh sửa
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleOpenShareeteCustomer(e?.edit)
                                    }
                                  >
                                    <Image
                                      w={"16px"}
                                      maxW={"16px"}
                                      h={"16px"}
                                      maxH={"16px"}
                                      src={iconShare}
                                    />{" "}
                                    Chia sẻ khách hàng
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleOpenDeleteCustomer(e?.edit)
                                    }
                                  >
                                    <Image src={icontrash} /> Xóa khách hàng
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Td>
                            <Td
                              bg={
                                rowIndex % 2 === 0
                                  ? "var(--color-main)"
                                  : "var(--fill-avatar)"
                              }
                              verticalAlign={"top"}
                            >
                              {rowIndex + 1}
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "auto";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (keyvalue === "contact") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "dateOfBirth") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "status") {
                                width = "10%";
                                textAlign = "center";
                              } else if (keyvalue === "gender") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "employee") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "saleBlock") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "saleArea") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "representativeGender") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "type") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "name") {
                                width = "25%";
                                textAlign = "start";
                                whiteSpace = "normal";
                                widthText = "118px";
                              } else if (keyvalue === "identificationInfo") {
                                width = "10%";
                                textAlign = "start";
                              } else if (
                                keyvalue === "identificationInfoBusiness"
                              ) {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "identityNumber") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "identificationNumber") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "permanentAddress") {
                                width = "40%";
                                textAlign = "end";
                                whiteSpace = "normal";
                                widthText = "171px";
                              } else if (keyvalue === "currentAddress") {
                                width = "40%";
                                textAlign = "end";
                                whiteSpace = "normal";
                                widthText = "146px";
                              } else if (keyvalue === "project") {
                                width = "20%";
                                textAlign = "start";
                                whiteSpace = "normal";
                                widthText = "143px";
                              } else {
                                width = "20%";
                                textAlign = "end";
                                whiteSpace = "inherit";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                  bg={
                                    rowIndex % 2 === 0
                                      ? "var(--color-main)"
                                      : "var(--fill-avatar)"
                                  }
                                  verticalAlign={"top"}
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"#293755"}
                                    // h={
                                    //   whiteSpace !== "inherit"
                                    //     ? "39.2px"
                                    //     : "72px"
                                    // }
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    // textOverflow="ellipsis"
                                    // display="-webkit-box"
                                    // sx={{
                                    //   WebkitLineClamp: "2",
                                    //   WebkitBoxOrient: "vertical",
                                    // }}
                                  >
                                    {formatTableValue(
                                      items[keyvalue],
                                      keyvalue,
                                      e.name
                                    )}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </Skeleton>
            </TableContainer>

            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                Showing {startEntry} to {endEntry} of {entries} entries
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    initialPage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
      {dataEdit && (
        <>
          <FormNew
            isOpen={isOpenCustomer}
            onClose={onCloseCustomer}
            onSubmit={onSubmitEdit}
            defaultValues={dataEdit}
            isEdit={true}
          />

          <FormNewBusiness
            isOpen={isOpenCustomerBusiness}
            onClose={onCloseCustomerBusiness}
            onSubmit={onSubmitEditBusiness}
            defaultValues={dataEdit}
            isEdit={true}
          />
        </>
      )}
      {dataDel && (
        <DeleteDialog
          isOpen={!!dataDel}
          onClose={handleCloseDeleteCustomer}
          title={"Xóa khách hàng"}
          description={
            <Flex display={"inline"}>
              "Bạn có chắc chắn muốn xóa khách hàng{" "}
              <Text fontWeight={"600"} display={"inline"}>
                {dataDel?.name}
              </Text>{" "}
              này không?"
            </Flex>
          }
          action={() => onSubmitDelete()}
        />
      )}

      {dataShare && (
        <FormShare
          isOpen={isOpenCustomerShare}
          onClose={onCloseCustomerShare}
          onSubmit={onSubmitShare}
          defaultValues={{ customer_shares: dataShare?.customer_shares }}
          isEdit={true}
        />
      )}

      {/* form */}
      {dataDetail?.isBusiness && (
        <FormInfoBusiness
          isOpen={!!dataDetail}
          onClose={handleCloseDetailCustomer}
          defaultValue={dataDetail}
        />
      )}

      {!dataDetail?.isBusiness && (
        <FormInfo
          isOpen={!!dataDetail}
          onClose={handleCloseDetailCustomer}
          defaultValue={dataDetail}
        />
      )}
    </>
  );
};

export default TableCustomers;
